import { render } from "./contentLibrary.vue?vue&type=template&id=0ef65861&scoped=true"
import script from "./contentLibrary.vue?vue&type=script&lang=js"
export * from "./contentLibrary.vue?vue&type=script&lang=js"

import "./contentLibrary.vue?vue&type=style&index=0&id=0ef65861&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef65861"]])

export default __exports__